import { render, staticRenderFns } from "./PrependAppendItemSlots.vue?vue&type=template&id=e9e83fde&"
import script from "./PrependAppendItemSlots.vue?vue&type=script&lang=js&"
export * from "./PrependAppendItemSlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports